package com.yendo.mx.ui.home

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.zIndex
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import coil3.compose.AsyncImage
import coil3.compose.LocalPlatformContext
import coil3.request.ImageRequest
import coil3.request.crossfade
import com.yendo.mx.models.RestauranteFirebase
import com.yendo.mx.models.SeccionHome
import com.yendo.mx.models.BannerYendo
import com.yendo.mx.models.FiltroHome
import com.yendo.mx.models.Producto
import com.yendo.mx.repository.HomeRepository
import com.yendo.mx.ui.HomeViewModel
import com.yendo.mx.ui.theme.*
import com.yendo.mx.ui.components.RestauranteRatingBadge
import com.yendo.mx.utils.ConfigManager
import com.yendo.mx.utils.EstadoCarga
import com.yendo.mx.utils.AdAnalyticsManager
import org.jetbrains.compose.resources.painterResource
import yendo.shared.generated.resources.*
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import com.yendo.mx.utils.getAhora
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun VistaSuperApp(
    isDark: Boolean,
    colorFondoTarjetas: Color,
    colorTextoPrincipal: Color,
    homeViewModel: HomeViewModel,
    estadoZona: EstadoCarga,
    direccionActiva: com.yendo.mx.models.DireccionGuardada?,
    fotoPerfilUrl: String,
    nombreUsuario: String,
    hayNotificacionesNoLeidas: Boolean,
    onNavegar: (String) -> Unit,
    onVerTodo: (SeccionHome) -> Unit,
    onRestauranteClick: (RestauranteFirebase) -> Unit,
    onProductoDirectoClick: (Producto?, RestauranteFirebase) -> Unit,
    onAbrirUbicacion: () -> Unit,
    onAbrirPerfil: () -> Unit,
    onAbrirNotificaciones: () -> Unit,
    procesandoAccion: (Boolean) -> Unit,
) {
    val state by homeViewModel.uiState.collectAsState()
    val coroutineScope = rememberCoroutineScope()
    val idZonaActual = (estadoZona as? EstadoCarga.Exito)?.id_zona ?: ""
    val configZona = ConfigManager.configActiva
    val comerciosDisponible = configZona?.modulos?.comerciosActivo ?: false
    val enviosDisponible = configZona?.modulos?.enviosActivo ?: false

    val listState = rememberSaveable(saver = LazyListState.Saver) { LazyListState() }

    LazyColumn(state = listState, modifier = Modifier.fillMaxSize(), contentPadding = PaddingValues(bottom = 100.dp)) {
        item {
            // 🚀 HEADER INTEGRADO EN EL SCROLL
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(start = 16.dp, end = 16.dp, top = 8.dp, bottom = 8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(
                    modifier = Modifier.weight(1f).clickable { onAbrirPerfil() },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(modifier = Modifier.size(45.dp)) {
                        if (fotoPerfilUrl.isNotEmpty()) {
                            AsyncImage(
                                model = ImageRequest.Builder(LocalPlatformContext.current).data(fotoPerfilUrl).crossfade(false).build(),
                                contentDescription = "Perfil",
                                modifier = Modifier.fillMaxSize().clip(RoundedCornerShape(12.dp)),
                                contentScale = ContentScale.Crop
                            )
                        } else {
                            Icon(Icons.Default.AccountCircle, "Perfil", tint = RosaYendo, modifier = Modifier.fillMaxSize())
                        }
                    }
                    Spacer(Modifier.width(12.dp))
                    Text(
                        text = "Hola, $nombreUsuario",
                        color = colorTextoPrincipal,
                        fontWeight = FontWeight.Black,
                        fontSize = 20.sp
                    )
                }

                IconButton(onClick = onAbrirNotificaciones) {
                    BadgedBox(
                        badge = { if (hayNotificacionesNoLeidas) Badge(containerColor = Color.Red) }
                    ) {
                        Icon(
                            imageVector = Icons.Default.Notifications,
                            contentDescription = "Notificaciones",
                            tint = Color.LightGray,
                            modifier = Modifier.size(28.dp)
                        )
                    }
                }
            }
        }
        item {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 12.dp)
                    .clickable { onAbrirUbicacion() }
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.LocationOn, null, tint = RosaYendo, modifier = Modifier.size(20.dp))
                    Spacer(Modifier.width(8.dp))
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = (direccionActiva?.titulo?.ifBlank { direccionActiva.tipoUbicacion } ?: "Seleccionar Ubicación"),
                            fontSize = 22.sp,
                            fontWeight = FontWeight.Black,
                            color = colorTextoPrincipal,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        if (direccionActiva != null && direccionActiva.direccion.isNotEmpty()) {
                            val calleSolo = direccionActiva.direccion.substringBefore(",").trim()
                            Text(
                                text = calleSolo,
                                fontSize = 13.sp,
                                color = Color.Gray,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                fontWeight = FontWeight.Medium
                            )
                        }
                    }
                    Spacer(Modifier.width(4.dp))
                    Icon(Icons.Default.KeyboardArrowDown, null, tint = colorTextoPrincipal, modifier = Modifier.size(20.dp))
                }
            }
        }
        item { BuscadorGlobal(isDark = isDark, onBuscarClick = { onNavegar("BUSCADOR") }) }
        item {
            CategoriasPrincipalesGrid(
                onNavegar = onNavegar,
                tienditaLocal = state.tienditaLocal,
                comerciosDisponible = comerciosDisponible,
                enviosDisponible = enviosDisponible,
                onTienditaClick = { tiendita -> 
                    val ahora = getAhora()
                    val estaPausado = tiendita.operacion.pausadoManualmente && tiendita.operacion.pausaHasta > ahora
                    val esVisible = tiendita.operacion.visible && tiendita.operacion.activoComercio && !tiendita.operacion.bloqueadoPorAdmin && !estaPausado
                    
                    if (esVisible) onRestauranteClick(tiendita)
                    else println("⚠️ Tiendita no visible por jerarquía")
                }
            )
        }
        item { FiltrosGlobales(state.filtros, colorFondoTarjetas) }
        if (state.secciones.isEmpty() && (estadoZona is EstadoCarga.Cargando || state.isLoading)) {
            item(key = "shimmer_banner") {
                com.yendo.mx.ui.components.BannerShimmerSkeleton(isDark = isDark)
            }
            items(count = 2, key = { "shimmer_home_$it" }, contentType = { "shimmer" }) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 6.dp),
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    com.yendo.mx.ui.components.RestauranteCardShimmerSkeleton(isDark = isDark, modifier = Modifier.weight(1f))
                    com.yendo.mx.ui.components.RestauranteCardShimmerSkeleton(isDark = isDark, modifier = Modifier.weight(1f))
                }
            }
        }
        items(items = state.secciones, key = { seccion -> seccion.id }) { seccion ->
            if (seccion.activo) {
                when (seccion.tipoBloque) {
                    "BANNERS" -> {
                        BannersDinamicos(
                            banners = seccion.listaBanners,
                            onAbrirNegocio = { idNegocio ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val doc = Firebase.firestore.collection("Negocios").document(idNegocio).get()
                                        val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (esVisible) {
                                            onRestauranteClick(rest)
                                        } else {
                                            println("⚠️ Negocio no visible desde banner full.")
                                        }
                                    } catch (e: Exception) { println("🚨 Error abriendo negocio: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAbrirProducto = { idProducto ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val prodDoc = Firebase.firestore.collection("Productos").document(idProducto).get()
                                        val prod = prodDoc.data<Producto>().copy(id = prodDoc.id)
                                        val restDoc = Firebase.firestore.collection("Negocios").document(prod.idRestaurante).get()
                                        val rest = restDoc.data<RestauranteFirebase>().copy(id = restDoc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (!esVisible) {
                                            println("⚠️ Negocio no visible para producto desde banner full.")
                                            return@launch
                                        }

                                        val estaAbierto = rest.operacion.estado == "ACTIVO" && !estaPausado
                                        val permiteProgramar = rest.operacion.programadoActivo
                                        if (estaAbierto || permiteProgramar) {
                                            onProductoDirectoClick(prod, rest)
                                            // 🚀 ANALÍTICA: Registro de vista desde Banner
                                            AdAnalyticsManager.logItemView(
                                                productId = prod.id,
                                                productName = prod.nombre,
                                                price = prod.precio,
                                                merchantName = rest.infoPublica.nombre
                                            )
                                        } else onProductoDirectoClick(null, rest)
                                    } catch (e: Exception) { println("🚨 Error abriendo producto: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAplicarCupon = { cupon -> /* Pronto */ }
                        )
                    }
                    "BANNERS_CUADRADOS" -> {
                        BannersCuadrados(
                            seccion = seccion,
                            onAbrirNegocio = { idNegocio ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val doc = Firebase.firestore.collection("Negocios").document(idNegocio).get()
                                        val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (esVisible) {
                                            onRestauranteClick(rest)
                                        } else {
                                            println("⚠️ Negocio no visible.")
                                        }
                                    } catch (e: Exception) { println("🚨 Error abriendo negocio: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAbrirProducto = { idProducto ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val prodDoc = Firebase.firestore.collection("Productos").document(idProducto).get()
                                        val prod = prodDoc.data<Producto>().copy(id = prodDoc.id)
                                        val restDoc = Firebase.firestore.collection("Negocios").document(prod.idRestaurante).get()
                                        val rest = restDoc.data<RestauranteFirebase>().copy(id = restDoc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (!esVisible) {
                                            println("⚠️ Negocio no visible.")
                                            return@launch
                                        }

                                        val estaAbierto = rest.operacion.estado == "ACTIVO" && !estaPausado
                                        val permiteProgramar = rest.operacion.programadoActivo
                                        if (estaAbierto || permiteProgramar) {
                                            onProductoDirectoClick(prod, rest)
                                            // 🚀 ANALÍTICA: Registro de vista desde Banner
                                            AdAnalyticsManager.logItemView(
                                                productId = prod.id,
                                                productName = prod.nombre,
                                                price = prod.precio,
                                                merchantName = rest.infoPublica.nombre
                                            )
                                        } else onProductoDirectoClick(null, rest)
                                    } catch (e: Exception) { println("🚨 Error abriendo producto: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAplicarCupon = { cupon -> /* Pronto */ }
                        )
                    }
                    "BANNERS_CUADRADOS_FULL" -> {
                        BannersCuadradosFull(
                            seccion = seccion,
                            onAbrirNegocio = { idNegocio ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val doc = Firebase.firestore.collection("Negocios").document(idNegocio).get()
                                        val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (esVisible) {
                                            onRestauranteClick(rest)
                                        } else {
                                            println("⚠️ Negocio no visible.")
                                        }
                                    } catch (e: Exception) { println("🚨 Error abriendo negocio: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAbrirProducto = { idProducto ->
                                coroutineScope.launch {
                                    procesandoAccion(true)
                                    try {
                                        val prodDoc = Firebase.firestore.collection("Productos").document(idProducto).get()
                                        val prod = prodDoc.data<Producto>().copy(id = prodDoc.id)
                                        val restDoc = Firebase.firestore.collection("Negocios").document(prod.idRestaurante).get()
                                        val rest = restDoc.data<RestauranteFirebase>().copy(id = restDoc.id)
                                        
                                        val ahora = getAhora()
                                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                        val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                        if (!esVisible) {
                                            println("⚠️ Negocio no visible.")
                                            return@launch
                                        }

                                        val estaAbierto = rest.operacion.estado == "ACTIVO" && !estaPausado
                                        val permiteProgramar = rest.operacion.programadoActivo
                                        if (estaAbierto || permiteProgramar) {
                                            onProductoDirectoClick(prod, rest)
                                            // 🚀 ANALÍTICA: Registro de vista desde Banner
                                            AdAnalyticsManager.logItemView(
                                                productId = prod.id,
                                                productName = prod.nombre,
                                                price = prod.precio,
                                                merchantName = rest.infoPublica.nombre
                                            )
                                        } else onProductoDirectoClick(null, rest)
                                    } catch (e: Exception) { println("🚨 Error abriendo producto: ${e.message}") }
                                    finally { procesandoAccion(false) }
                                }
                            },
                            onAplicarCupon = { cupon -> /* Pronto */ }
                        )
                    }
                    "CARRUSEL_LARGO" -> EnchufeCarruselLargo(seccion, idZonaActual, colorTextoPrincipal, onVerTodo, onRestauranteClick)
                    "CARRUSEL_CUADRADO" -> EnchufeCarruselCuadrado(
                        seccion = seccion, idZonaActual = idZonaActual, colorTexto = colorTextoPrincipal, onVerTodo = onVerTodo,
                        onProductoClick = { producto ->
                            coroutineScope.launch {
                                procesandoAccion(true)
                                try {
                                    val restDoc = Firebase.firestore.collection("Negocios").document(producto.idRestaurante).get()
                                    val rest = restDoc.data<RestauranteFirebase>().copy(id = restDoc.id)
                                    
                                    val ahora = getAhora()
                                    val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                                    val esVisible = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado

                                    if (!esVisible) {
                                        println("⚠️ Negocio no visible para producto en carrusel.")
                                        return@launch
                                    }

                                    val estaAbierto = rest.operacion.estado == "ACTIVO" && !estaPausado
                                    val permiteProgramar = rest.operacion.programadoActivo
                                    if (estaAbierto || permiteProgramar) {
                                        onProductoDirectoClick(producto, rest)
                                        // 🚀 ANALÍTICA: Registro de vista desde Carrusel
                                        AdAnalyticsManager.logItemView(
                                            productId = producto.id,
                                            productName = producto.nombre,
                                            price = producto.precio,
                                            merchantName = rest.infoPublica.nombre
                                        )
                                    } else onProductoDirectoClick(null, rest)
                                } catch (e: Exception) { println("🚨 Error abriendo dueño del producto: ${e.message}") }
                                finally { procesandoAccion(false) }
                            }
                        }
                    )
                }
            }
        }
    }
}
